import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { useState } from "react";

import AuthInputTooltip from "./auth_input_tooltip";

const PasswordField = ({
  id,
  name,
  label,
  placeholder,
  value,
  onChange,
  autoComplete,
  required = true,
  tooltipTitle,
  tooltipBody,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="auth-input-wrap position-relative mb15">
      <input
        id={id}
        name={name}
        type={showPassword ? "text" : "password"}
        className="form-control auth-password-input"
        placeholder={placeholder}
        value={value}
        required={required}
        autoComplete={autoComplete}
        aria-label={label}
        onChange={(event) => onChange(event.target.value)}
      />
      <div className="position-absolute auth-password-controls d-flex align-items-center">
        {tooltipTitle && tooltipBody ? (
          <span className="d-inline-flex align-items-center mr1">
            <AuthInputTooltip title={tooltipTitle} body={tooltipBody} />
          </span>
        ) : null}
        <button
          type="button"
          className="btn auth-icon-button auth-password-toggle"
          aria-label={showPassword ? "Hide password" : "Show password"}
          onClick={() => setShowPassword((current) => !current)}
        >
          <FontAwesomeIcon
            icon={["far", showPassword ? "eye-slash" : "eye"]}
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  );
};

PasswordField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  autoComplete: PropTypes.string.isRequired,
  required: PropTypes.bool,
  tooltipTitle: PropTypes.string,
  tooltipBody: PropTypes.string,
};

export default PasswordField;
